import {
  del,
  get,
  patch,
  post,
  type RequestConfig,
} from "../shared/api-client";
import type {
  ApiItemResponse,
  ListQuery,
  PaginatedResult,
} from "@project/types/location";
import type {
  CsrInquiryPayload,
  CsrInquiryRecord,
} from "@project/types/csr-inquiry";
import {
  JIVANDHARA_BASE,
  SILENT_LIST,
  fetchListPage,
  unwrapItem,
} from "./list-api-helpers";

const BASE = `${JIVANDHARA_BASE}/csr-partnership-inquiries`;
const SILENT: RequestConfig = { showNotification: false };

class CsrInquiryService {
  listPage = (
    query: ListQuery = {}
  ): Promise<PaginatedResult<CsrInquiryRecord>> => {
    return fetchListPage<CsrInquiryRecord>(`${BASE}/`, query);
  };

  get = async (id: number): Promise<CsrInquiryRecord | undefined> => {
    const data = await get<
      ApiItemResponse<CsrInquiryRecord> | CsrInquiryRecord
    >(`${BASE}/${id}/`, SILENT_LIST);
    return unwrapItem(data);
  };

  create = async (
    payload: CsrInquiryPayload
  ): Promise<CsrInquiryRecord | undefined> => {
    const data = await post<
      ApiItemResponse<CsrInquiryRecord> | CsrInquiryRecord,
      CsrInquiryPayload
    >(`${BASE}/`, payload, SILENT);
    return unwrapItem(data);
  };

  update = async (
    id: number,
    payload: Partial<CsrInquiryPayload>
  ): Promise<CsrInquiryRecord | undefined> => {
    const data = await patch<
      ApiItemResponse<CsrInquiryRecord> | CsrInquiryRecord,
      Partial<CsrInquiryPayload>
    >(`${BASE}/${id}/`, payload, SILENT);
    return unwrapItem(data);
  };

  delete = async (id: number): Promise<void> => {
    await del(`${BASE}/${id}/`, SILENT);
  };
}

export const csrInquiryService = new CsrInquiryService();
